import "bootstrap/dist/css/bootstrap.min.css";
import "./bootstrap-custom.css";
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import App from "./App";
import axios from "axios";
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const APIHOSTNAME = "https://mixta39.dev/phpapi/api";
const API_URL_SESSION = `${APIHOSTNAME}/verifySession.php`;

const Root = () => {
    const [user, setUser] = useState(null);
    const [isCheckingSession, setIsCheckingSession] = useState(true);
    const navigate = useNavigate(); // Redirección

    useEffect(() => {
        const checkSession = async () => {
            const userData = localStorage.getItem("user");

            if (!userData) {
                console.warn("🔴 No hay usuario guardado, redirigiendo a login...");
                setUser(null);
                setIsCheckingSession(false);
                navigate("/login"); // 🔹 Redirección a login
                return;
            }

            try {
                const parsedUser = JSON.parse(userData);
                if (parsedUser && parsedUser.email && parsedUser.token) {
                    console.log("✅ Usuario autenticado localmente:", parsedUser);
                    
                    const response = await axios.get(API_URL_SESSION, {
                        headers: {
                            Authorization: `Bearer ${parsedUser.token}`,
                        },
                    });

                    console.log(response.data);
                    setUser(parsedUser);
                } else {
                    throw new Error("Estructura inválida en userData");
                }
            } catch (error) {
                console.error("❌ Error al verificar la sesión:", error);
                localStorage.removeItem("user");
                setUser(null);
                navigate("/login"); // 🔹 Redirección si hay error
            } finally {
                setIsCheckingSession(false);
            }
            setIsCheckingSession(false);
        };

        checkSession();
    }, [navigate]); // 🔹 Asegura que `navigate` esté en la dependencia

    if (isCheckingSession) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <h3>Verificando sesión...</h3>
            </div>
        );
    }

    return clientId ? (
        <GoogleOAuthProvider clientId={clientId}>
            <App user={user} />
        </GoogleOAuthProvider>
    ) : (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <h3>Error: Google Client ID no configurado</h3>
        </div>
    );
};

// 🔹 Ahora `Root` está dentro de `Router`
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Router>
        <Root />
    </Router>
);
